import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Snackbar } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faExclamationTriangle,
  faInfoCircle,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';

import { Message, MessageContent, ToastArea, ToastType } from './style';
import { clearToast } from '../../../actions/System';

const Toast = () => {
  const dispatch = useDispatch();

  const { open, message = '', type } = useSelector(({ system }) => ({
    open: system?.toast?.open || false,
    message: system?.toast?.message || '',
    type: system?.toast?.type || null,
  }));

  const [toastType, setToastType] = useState({
    icon: faTimes,
    color: '#f44336',
  });

  useEffect(() => {
    switch (type) {
      case 'success':
        setToastType({ icon: faCheck, color: '#4caf50' });
        break;
      case 'warning':
        setToastType({ icon: faExclamationTriangle, color: '#ff9800' });
        break;
      case 'info':
        setToastType({ icon: faInfoCircle, color: '#2196f3' });
        break;
      default:
        setToastType({ icon: faTimes, color: '#f44336' });
        break;
    }
  }, [type]);

  const handleClose = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(clearToast());
  };

  return (
    <ToastArea>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        onClose={handleClose}
        open={open}
        autoHideDuration={5000}
      >
        <ToastType
          color={toastType.color}
          message={
            <Message>
              <FontAwesomeIcon icon={toastType.icon} />
              <MessageContent>{message}</MessageContent>
            </Message>
          }
          action={[
            <IconButton key="close" onClick={() => dispatch(clearToast())}>
              <FontAwesomeIcon icon={faTimes} />
            </IconButton>,
          ]}
        ></ToastType>
      </Snackbar>
    </ToastArea>
  );
};

export default Toast;
